import { getCurrencyPrecision } from '@cast/utils';

import { Money } from 'components/money';

import { CostDetailsTooltip } from './CostDetailsTooltip';
import { TrafficRatioBars } from './TrafficRatioBars';

import { Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

type Props = {
  egress: number;
  ingress: number;
  stackProps?: StackProps;
};

export const CostsCell = ({ egress, ingress, stackProps }: Props) => {
  const value = egress + ingress;

  if (!value) {
    return <>-</>;
  }

  return (
    <CostDetailsTooltip egress={egress} ingress={ingress}>
      <Stack gap={1} width="200px" {...stackProps}>
        <Money
          amount={value}
          fixed={getCurrencyPrecision(value)}
          precision={getCurrencyPrecision(value)}
        />
        <TrafficRatioBars egress={egress} ingress={ingress} size="md" />
      </Stack>
    </CostDetailsTooltip>
  );
};
